/**
 *  UI-REFACTORED
 *    FROM --> ./legacy-web/src/main/js/js/aa/home/homepage-2.0.0.js
 *    TO   --> ./webapps/homepage-web/src/main/assets/js/home/homepage-2.0.0.js
 **/

/* global dynMoreOptionsRoundTrip:true */
/* global dynMoreOptionsOneWay:true */
/* global dynAavDeepLinkURL:true */
/* global dynUserLocale:true */
/* global onMessage:true */
/* global aaHeroSlides:true */

/*
 * Scripts used by the homepage
 */

AAcom(
    "browserdetect",
    "commonsetup",
    "utilities",
    "ajax",
    "aaDatePicker",
    "aaAutoComplete",
    "travelDates",
    "nearestAirportLookup",
    "airportLookup",
    "aaMobileDatePicker",
    (AAUI) => {
        let $fhServiceClass = $j('#reservationFlightSearchForm label[for="fhServiceClass"]'),
            $returningFromLabel = $j('#reservationFlightSearchForm label[for="aa-returningFrom"]'),
            $advBookingSearch = $j("#advBookingSearch"),
            $aairPassParent = $j("#flightSearchForm\\.tripType\\.aairPass").parent(),
            $aairPass = $j("#flightSearchForm\\.tripType\\.aairPass"),
            $tripLinkParent = $j("#flightSearchForm\\.tripType\\.tripLink").parent(),
            $redeemMilesParent = $j("#flightSearchForm\\.tripType\\.redeemMiles").parent(),
            $redeemMiles = $j("#flightSearchForm\\.tripType\\.redeemMiles"),
            $bookingCheckboxContainer = $j("#bookingCheckboxContainer"),
            $defaultSubmit = $j("#flightSearchForm\\.button\\.reSubmit"),
            $vacationSubmit = $j("#flightSearchForm\\.button\\.vacationSubmit"),
            $departingDateField = $device.mobile && $device.viewport() !== "desktop" ? $j("#departDate") : $j("#aa-leavingOn"),
            $returningDateField = $device.mobile && $device.viewport() !== "desktop" ? $j("#returnDate") : $j("#aa-returningFrom"),
            $flightSearchSubmitButton = $j("#flightSearchFormSubmitButton"),
            userSelectedDate = false,
            previousDepartDate = new Date(),
            previousReturnDate = new Date(),
            defaultWasSetOnRoundTripHotel = false,
            returningDateFieldIsDirty = false,
            departingDateFieldIsDirty = false,
            handlebarWorker,
            AWARD_LEGACY_MAX_PASSENGER = 6,
            findYourTripsCreditChecksClicked = false,
            airpassCompanionAllowed = "true" === AAUI.getProperty('airpassCompanionAllowed'),
            airPassNextGenAccount = "true" === AAUI.getProperty('airPassNextGenAccount'),
            tripLinkAccount = "true" === AAUI.getProperty('tripLinkAccount'),
            corporateAccount = "true" === AAUI.getProperty('corporateAccount'),
            viewChangeText = AAUI.getProperty('viewChangeText'),
            isSecure = AAUI.getProperty('account.isSecure') === 'true';

        let initReactivateDialog = () => {
            const showPopup = $j("#expiredDialog").data().showPopup;

            if (showPopup) {
                const aaUtil = new aa_Utilities();

                let props = {
                    width: 582,
                    toggleScroll: true,
                    showClose: false,
                    dialogClass: "reactivate-modal",
                    buttons: [{
                            name: AAcom.prototype.getProperty("profile.reactivate.modal.button.reactivate"),
                            cssClass: "btn btn-primary",
                            callback: () => {
                                window.location = "/aadvantage-program/profile/reactivate-miles?from=modal";
                            },
                            closeDialog: false
                        },
                        {
                            name: AAcom.prototype.getProperty("profile.reactivate.modal.button.dismiss"),
                            cssClass: "btn btn-secondary",
                            callback: () => {
                                AAUI.ajaxRequest({
                                    url: "/aadvantage-program/profile/ajax/setremindmelater",
                                    type: "GET",
                                    dataType: "json",
                                    timeout: 50000,
                                    onSuccess: (jsonResponse, textStatus) => {},
                                    onError: () => {},
                                    onComplete: () => {
                                        aaUtil.aaDialog("expired").closeDialog();
                                    }
                                });
                            },
                            closeDialog: true
                        },
                        {
                            id: "reactivate-no-thanks-link",
                            name: AAcom.prototype.getProperty("profile.reactivate.modal.link.nothanks"),
                            cssClass: "btn-secondary btn-link reactivate-no-thanks-link",
                            closeDialog: true,
                            callback: () => {
                                AAUI.ajaxRequest({
                                    url: "/aadvantage-program/profile/ajax/setdonotshowcookie",
                                    type: "GET",
                                    dataType: "json",
                                    timeout: 50000,
                                    onSuccess: (jsonResponse, textStatus) => {},
                                    onError: e => {},
                                    onComplete: () => {
                                        aaUtil.aaDialog("expired").closeDialog();
                                    }
                                });

                                return false;
                            }
                        }
                    ]
                };

                if ($device.mobile) {
                    props.showFullScreen = true;
                }

                aaUtil.aaDialog("expired", props).openDialog();

                waReport();
            }
        };

        var waReport = function() {
            setTimeout(() => {
                if (typeof utag === "undefined") {
                    waReport();
                } else {
                    try {
                        utag.link({
                            event_category: "Modal",
                            event_action: "View",
                            event_name: "get your miles back",
                            page_name: "Home",
                            channel: "Content",
                            site_indicator: "AAcom"
                        });
                    } catch (e) {}
                }
            }, 200);
        };

        var _getSelectedFindFlightType = function() {
            if ($j("#round-trip-hotel").prop("checked")) {
                return "roundTripHotel";
            }

            if ($j("#flightSearchForm\\.tripType\\.oneWay").prop("checked")) {
                return "oneWay";
            }

            return "roundTrip";
        };

        var _resetDateFields = function() {
            if (!defaultWasSetOnRoundTripHotel) {
                return;
            }

            $departingDateField.datepicker("setDate", previousDepartDate);
            $returningDateField.datepicker("setDate", previousReturnDate);
            defaultWasSetOnRoundTripHotel = false;
        };

        var _showRoundTrip = function() {
            $fhServiceClass.hide();
            $returningFromLabel.removeClass("is-hidden");
            $advBookingSearch.show();
            $bookingCheckboxContainer.show();
            $defaultSubmit.show();
            $vacationSubmit.hide();
            if (isSecure) {
                $flightSearchSubmitButton.removeClass("offset3 offset8");
            } else {
                $flightSearchSubmitButton.removeClass("offset4 offset8");
            }

            _setMinDates(new Date());
            _resetDateFields();
            AAUI.datePickerA11Y();
            if (isSecure && (airPassNextGenAccount || corporateAccount)) {
                $j(".travelTypeLayout").show();
                $j(".vacationLayout").hide();
            }
        };

        var _showOneWay = function() {
            $fhServiceClass.hide();
            $returningFromLabel.addClass("is-hidden");
            $returningFromLabel.next().addClass("is-hidden");
            $advBookingSearch.show();
            $bookingCheckboxContainer.show();
            $defaultSubmit.show();
            $vacationSubmit.hide();
            if (isSecure) {
                $flightSearchSubmitButton.removeClass("offset8").addClass("offset3");
            } else {
                $flightSearchSubmitButton.removeClass("offset8").addClass("offset4");
            }

            _setMinDates(new Date());
            _resetDateFields();
            AAUI.datePickerA11Y();
            if (isSecure && (airPassNextGenAccount || corporateAccount)) {
                $j(".travelTypeLayout").show();
                $j(".vacationLayout").hide();
            }
        };

        var _showRoundTripHotel = function() {
            var minDate = new Date();
            $fhServiceClass.show();
            $returningFromLabel.removeClass("is-hidden");
            $advBookingSearch.hide();
            $bookingCheckboxContainer.hide();
            $defaultSubmit.hide();
            $vacationSubmit.show();
            $j("#reservationFlightSearchForm input[type=checkbox]")
                .prop("checked", false)
                .trigger("change");

            if (isSecure && (airPassNextGenAccount || corporateAccount)) {
                $j(".travelTypeLayout").hide();
                $j(".vacationLayout").show();
            }

            $flightSearchSubmitButton.removeClass("offset4 offset8");

            minDate.setDate(minDate.getDate() + 2);
            var departDate = _getDateFromDatePicker("aa-leavingOn");
            var returnDate = _getDateFromDatePicker("aa-returningFrom");
            if (_getDateDifferenceInDaysFromToday(departDate) <= 1) {
                previousDepartDate = departDate;
                previousReturnDate = returnDate;
                defaultWasSetOnRoundTripHotel = true;
            }
            _setMinDates(minDate);
            AAUI.datePickerA11Y();
        };

        var _setMinDates = function(departDate) {
            $departingDateField.datepicker("option", "minDate", departDate);
            if (_getSelectedFindFlightType() === "oneWay") {
                $returningDateField.datepicker("setDate", "");
            } else {
                $returningDateField.datepicker("option", "minDate", departDate);
            }
            AAUI.initDatepickerA11Y();
        };

        var _getDateDifferenceInDaysFromToday = function(date) {
            if (!date) {
                return 0;
            }

            var TIME_TO_DAY_FACTOR = 1000 * 60 * 60 * 24;
            var today = new Date();
            var todayDate = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
            var otherDate = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());

            return Math.floor((otherDate - todayDate) / TIME_TO_DAY_FACTOR);
        };

        var _getDateFromDatePicker = function(datepickerId) {
            return $j("#" + datepickerId).datepicker("getDate");
        };

        var _setDateDefaultsForRoundTripHotel = function() {
            var roundTripHotelDepartDate = new Date();
            var roundTripHotelReturnDate = new Date();
            roundTripHotelDepartDate.setDate(roundTripHotelDepartDate.getDate() + 2);
            $departingDateField.datepicker("setDate", roundTripHotelDepartDate);
            var returnDate = _getDateFromDatePicker("aa-returningFrom");
            var altReturnDate =
                $returningDateField.attr("data-historicReturnDate") === "" ?
                "" :
                new Date($returningDateField.attr("data-historicReturnDate"));
            if (altReturnDate || returningDateFieldIsDirty) {
                if (!returningDateFieldIsDirty &&
                    returnDate.getMonth() !== altReturnDate.getMonth() &&
                    returnDate.getDate() !== altReturnDate.getDate() &&
                    returnDate.getYear() !== altReturnDate.getYear()
                ) {
                    roundTripHotelReturnDate.setDate(roundTripHotelReturnDate.getDate() + 9);
                    $returningDateField.datepicker("setDate", roundTripHotelReturnDate);
                }
            } else {
                roundTripHotelReturnDate.setDate(roundTripHotelReturnDate.getDate() + 9);
                $returningDateField.datepicker("setDate", roundTripHotelReturnDate);
            }
        };

        var _setDateDefaultsForFlightOnly = function() {
            var searchDate = new Date();
            var futureDate = new Date();

            $departingDateField.datepicker("setDate", searchDate);
            _setMinDates(searchDate);
            futureDate.setDate(futureDate.getDate() + 7);

            $returningDateField.datepicker("setDate", futureDate);
        };

        var _updateFindFlightsView = function(view) {
            switch (view) {
                case "roundTrip":
                    _showRoundTrip();
                    break;
                case "oneWay":
                    _showOneWay();
                    break;
                case "roundTripHotel":
                    _showRoundTripHotel();
                    break;
            }
        };

        var _toggleSearchView = function(selected) {
            if ("roundTripHotel" === selected) {
                _showRoundTripHotel();
            } else {
                var tripType = $j("#reservationFlightSearchForm input[type=radio][name=tripType]:checked").val();
                _updateFindFlightsView(tripType);
                initTripLink();
            }
        };

        var _toggleRedeemMiles = function(isRedeemMiles) {
            var isAirPass = false;
            if (isRedeemMiles) {
                $j("#flightSearchForm\\.tripType\\.tripLink").prop("disabled", true);
                $aairPass.prop("disabled", true);
            } else {
                $j("#flightSearchForm\\.tripType\\.tripLink").prop("disabled", false);
                $aairPass.prop("disabled", false);
                isAirPass = $aairPass.prop("checked") || false;
            }

            _toggleRestrictedMarketPassengerOptions(isAirPass);
        };

        var _toggleTripLink = function(isTripLink) {
            if (isTripLink) {
                _toggleAirpass(false);
                $aairPass.prop("checked", false).prop("disabled", true);
                $redeemMiles.prop("disabled", true).prop("checked", false); // desktop miles checkbox
                $j('#awardBooking2').prop("disabled", true).prop("checked", false); // mobile miles checkbox
                $j("#flightSearchForm\\.tripType\\.tripLink").prop("checked", true);
                $j('#bookingForm #tripLink').prop("checked", true).prop("disabled", false);
            } else {
                $redeemMiles.prop("disabled", false);
                $j('#awardBooking2').prop("disabled", false);
                $aairPass.prop("disabled", false);
                $j("#flightSearchForm\\.tripType\\.tripLink").prop("checked", false);
                $j('#bookingForm #tripLink').prop("checked", false);
            }
            initializePassengersDropdown();
        };

        var _toggleCorporate = function(isCorporate) {
            if (isCorporate) {
                _toggleAirpass(false);
                $aairPass.prop("checked", false).prop("disabled", true);
                $redeemMiles.prop("disabled", true).prop("checked", false); // desktop miles checkbox
                $j('#awardBooking2').prop("disabled", true).prop("checked", false); // mobile miles checkbox
                $j("#flightSearchForm\\.tripType\\.tripLink").prop("checked", true);
                $j('#bookingForm #tripLink').prop("checked", true).prop("disabled", false);
            } else {
                $redeemMiles.prop("disabled", false);
                $j('#awardBooking2').prop("disabled", false);
                $aairPass.prop("disabled", false);
                $j("#flightSearchForm\\.tripType\\.tripLink").prop("checked", false);
                $j('#bookingForm #tripLink').prop("checked", false);
            }
            initializePassengersDropdown();
        };

        var _toggleAirpass = function(isAirpass) {
            if (isAirpass) {
                $aairPass.prop("checked", true).prop("disabled", false);
                $redeemMiles.prop("disabled", true).prop("checked", false);
                $j('#awardBooking2').prop("disabled", true).prop("checked", false);
                $j("#flightSearchForm\\.tripType\\.tripLink").prop("disabled", true).prop("checked", false);
                $j('#bookingForm #tripLink').prop("checked", false).prop("disabled", true);
                _toggleAirpassPassengerOptions(airpassCompanionAllowed);
            } else {
                $redeemMiles.prop("disabled", false);
                $j('#awardBooking2').prop("disabled", false);
                $aairPass.prop("disabled", false).prop("checked", false);
                $j("#flightSearchForm\\.tripType\\.tripLink").prop("disabled", false);
                $j('#bookingForm #tripLink').prop("disabled", false);
                _toggleMaxPassengerOptions();
            }
        };

        var _setTripLinkToSession = function(isTripLink) {
            // Business rule:
            // If the user unchecks the triplink checkbox,
            // do not default it to checked again during the session
            AAUI.ajaxRequest({
                url: "/home/ajax/triplinkSelection",
                type: "GET",
                data: { tripLink: isTripLink },
                dataType: "JSON",
                timeout: 5000,
                showBusy: false
            });
        };

        var _setCorporateToSession = function(isCorporate) {
            // Business rule:
            // If the user unchecks the triplink checkbox,
            // do not default it to checked again during the session
            AAUI.ajaxRequest({
                url: "/home/ajax/triplinkSelection", // ??
                type: "GET",
                data: { corporate: isCorporate },
                dataType: "JSON",
                timeout: 5000,
                showBusy: false
            });
        };

        var _setAirPassToSession = function(isAirPass) {
            AAUI.ajaxRequest({
                url: "/home/ajax/airPassSelection",
                type: "GET",
                data: { airPass: isAirPass },
                dataType: "JSON",
                timeout: 5000,
                showBusy: false
            });
        };

        var getDateInUSFormat = function(inputDateId) {
            var dateFromDatePicker = _getDateFromDatePicker(inputDateId);
            if (dateFromDatePicker === null) {
                return "";
            }
            return (
                dateFromDatePicker.getMonth() +
                1 +
                "/" +
                dateFromDatePicker.getDate() +
                "/" +
                dateFromDatePicker.getFullYear()
            );
        };

        var initializePassengersDropdown = function() {
            var passengerDropdown;
            var corporateAcctSelected = false;
            if ($j('#travelType').val() === "business") {
                corporateAcctSelected = true;
            }

            if ($device.mobile) {
                passengerDropdown = $j("#passengerCount");
                if (corporateAcctSelected) {
                    $j('#passengerCount option[value="1"]').prop('selected', true)
                }
            } else {
                passengerDropdown = $j("#flightSearchForm\\.adultOrSeniorPassengerCount");
                if (corporateAcctSelected) {
                    $j('#flightSearchForm\\.adultOrSeniorPassengerCount option[value="1"]').prop('selected', true)
                }
            }
            passengerDropdown.prop('disabled', corporateAcctSelected ? true : false);
        };

        var _getAirports = function() {
            return [
                $j("#reservationFlightSearchForm\\.originAirport").val(),
                $j("#reservationFlightSearchForm\\.destinationAirport").val()
            ];
        };

        var _toggleAirpassPassengerOptions = function (companionAllowed) {
            var currentPaxCount = $j("#flightSearchForm\\.adultOrSeniorPassengerCount").val();

            if (currentPaxCount == 2) {
                $j('#flightSearchForm\\.adultOrSeniorPassengerCount option[value="2"]')
                    .prop("selected", true);
            } else {
                $j('#flightSearchForm\\.adultOrSeniorPassengerCount option[value="1"]')
                    .prop("selected", true);
            }

            if (companionAllowed) {
                $j('#flightSearchForm\\.adultOrSeniorPassengerCount').prop("disabled", false);
                $j('#flightSearchForm\\.adultOrSeniorPassengerCount option[value="2"]').prop("hidden", false);
                $j('#passengerCount').prop('disabled', false);
                $j('#passengerCount option[value="2"]').prop("hidden", false);
            } else {
                $j('#flightSearchForm\\.adultOrSeniorPassengerCount option[value="2"]')
                    .prop("disabled", true)
                    .prop("hidden", true);
            }

            for (var i = 3; i <= 9; i++) {
                $j('#flightSearchForm\\.adultOrSeniorPassengerCount option[value="' + i +'"]')
                    .prop("disabled", true)
                    .prop("hidden", true);
                $j('#passengerCount option[value="' + i +'"]')
                    .prop("disabled", true)
                    .prop("hidden", true);
            }
        };

        var _toggleMaxPassengerOptions = function() {
            for (var i = 2; i <= 9; i++) {
                $j('#flightSearchForm\\.adultOrSeniorPassengerCount option[value="' + i + '"]')
                    .prop("disabled", false)
                    .prop("hidden", false);
                $j('#passengerCount option[value="' + i + '"]')
                    .prop("disabled", false)
                    .prop("hidden", false);
            }
        };

        var _toggleRestrictedMarketPassengerOptions = function(isAirPass) {
            if (isAirPass) {
                _toggleAirpassPassengerOptions(airpassCompanionAllowed);
            } else {
                _toggleMaxPassengerOptions();
            }
        };

        var _initializeAirportInput = function() {
            $j("#reservationFlightSearchForm\\.originAirport,#reservationFlightSearchForm\\.destinationAirport")
                .on(
                    "blur",
                    function () {
                        var isAirPass = $aairPass.prop("checked") || false;
                        _toggleRestrictedMarketPassengerOptions(isAirPass);
                    }
                );
        };

        var _initBookingForm = function() {
            var isRedeemMiles = $redeemMiles.prop("checked"),
                isAirpass = $aairPass.prop("checked"),
                isTripLink = $j("#flightSearchForm\\.tripType\\.tripLink").prop("checked");

            if (isRedeemMiles) {
                _toggleRedeemMiles(true);
            } else if (isAirpass) {
                _toggleAirpass(true);
            } else if (isTripLink) {
                _toggleTripLink(isTripLink);
            }

            AAUI.onChange("#reservationFlightSearchForm input[type=radio][name=tripType]", function() {
                _updateFindFlightsView(this.value);
            });

            AAUI.onChange("#reservationFlightSearchForm input[type=radio][name=flight]", function() {
                _toggleSearchView(this.value);
            });

            AAUI.onChange("#reservationFlightSearchForm input[type=checkbox]", function(e) {
                switch (this.id) {
                    case "flightSearchForm.tripType.redeemMiles":
                        _toggleRedeemMiles(this.checked);
                        break;
                    case "flightSearchForm.tripType.aairPass":
                        _toggleAirpass(this.checked);
                        _setAirPassToSession(this.checked);
                        break;
                    case "flightSearchForm.tripType.tripLink":
                        _toggleTripLink(this.checked);
                        _setTripLinkToSession(this.checked);
                        break;
                }
            });

            AAUI.onClick("#flightSearchForm\\.button\\.vacationSubmit", function(e) {
                e.preventDefault();
                var $dataLink = $j(this).data("link"),
                    localeParam = "?ADID=AACM-DEP-ALL-09-01";
                if (dynUserLocale == "en_CA") {
                    localeParam = "?ADID=AACA-DEP-ALL-14-31";
                } else if (dynUserLocale == "es_MX") {
                    localeParam = "?ADID=AAMX-DEP-ALL-14-31";
                }
                var flightHotelURL =
                    dynAavDeepLinkURL +
                    localeParam +
                    "&searchType=matrix&" +
                    "adults=" +
                    $j("#flightSearchForm\\.adultOrSeniorPassengerCount").val() +
                    "&";
                flightHotelURL += "rooms=1" + "&" + "serviceclass=" + $j("#fhServiceClass").val() + "&";
                flightHotelURL +=
                    "from_date=" +
                    getDateInUSFormat("aa-leavingOn") +
                    "&" +
                    "to_date=" +
                    getDateInUSFormat("aa-returningFrom") +
                    "&";
                flightHotelURL +=
                    "from_city_code=" +
                    $j("#reservationFlightSearchForm\\.originAirport").val() +
                    "&" +
                    "to_city_code=" +
                    $j("#reservationFlightSearchForm\\.destinationAirport").val() +
                    "&" +
                    "to_time=0&" +
                    "from_time=0";
                if (typeof interimMessages !== "undefined") {
                    interimMessages().showInterimMessage({
                        url: flightHotelURL,
                        dialogName: $dataLink
                    });
                } else {
                    window.open(flightHotelURL, "aavacations");
                }
            });

            $j("#flightSearchForm\\.button\\.reSubmit").on("click", function(e) {
                e.preventDefault();
                $j("#flightSearchForm\\.adultOrSeniorPassengerCount").prop("disabled", false);

                // Show special promo only for revenue path (not SPA award or airpass next gen)
                var isRedeemMiles = $redeemMiles.prop("checked");
                var isAirPass = $aairPass.prop("checked");
                if (isRedeemMiles || (isAirPass && airPassNextGenAccount)) {
                    $j(this)
                        .parents("form:first")
                        .submit();
                } else {
                    $j("body")
                        .aaBusy({
                                message: AAUI.getProperty("loadingTxt"),
                                form: $j(this).parents("form:first")
                            })
                        .start();
                }

                $j("#showMoreOptions").val(false);
            });
        };

        var initTripLink = function() {
            var tripLinkSelectedStatus = sessionStorage.getItem('triplinkUserSelectionMade');
            var isSecure = AAUI.getProperty("account.isSecure") === "true";

            if (typeof tripLinkSelectedStatus === 'undefined' || tripLinkSelectedStatus === null || tripLinkSelectedStatus === 'false') {
                $j("#flightSearchForm\\.tripType\\.tripLink").prop("checked", false);
                _toggleRedeemMiles(false);
                _toggleAirpass(false);
                _toggleTripLink(false);
            } else if (isSecure && tripLinkAccount && tripLinkSelectedStatus === 'true') {  // do we include corporateAccount?
                $j("#flightSearchForm\\.tripType\\.tripLink").prop("checked", true);
                _toggleTripLink(true);
            }
        };

        var initTripLinkMobile = function () {
            var tripLinkSelectedStatus = sessionStorage.getItem('triplinkUserSelectionMade');
            var isSecure = AAUI.getProperty("account.isSecure") === "true";

            if (typeof tripLinkSelectedStatus === 'undefined' || tripLinkSelectedStatus === null || tripLinkSelectedStatus === 'false') {
                _toggleTripLink(false);
                _setTripLinkToSession(false);
                $j('#bookingForm #tripLink').prop("checked", false);
                $j('#bookingForm #tripLink').prop("disabled", false);
                $j('#awardBooking2').prop("disabled", false);
            } else if (tripLinkSelectedStatus === 'true' && isSecure) {
                $j('#bookingForm #tripLink').prop("checked", true);
                $j('#bookingForm #tripLink').prop("disabled", false);
                $j('#awardBooking2').prop("checked", false);
                $j('#awardBooking2').prop("disabled", true);
                _toggleTripLink(true);
                _setTripLinkToSession(true);
            }
        };

        function getCurrentSearchFields() {
            let currentSearch = {
                originAirport: {
                    inputField: $j('#segments0\\.origin'),
                    errorField: $j('#segments0\\.originError')
                },
                originTravelDate: {
                    inputField: $j('#departDate'),
                    errorField: $j('#departDateError')
                },
                destinationAirport: {
                    inputField: $j('#segments0\\.destination'),
                    errorField: $j('#segments0\\.destinationError')
                },
                destinationTravelDate: {
                    inputField: $j('#returnDate'),
                    errorField: $j('#returnDateError')
                },
                tripType:  getMobileCurrentTripType(),
                awardBooking: $j('#awardBooking2').prop('checked'),
                travelType: {
                    inputField: $j('#travelType'),
                    errorField: $j('#travelTypeError')
                }
            };

            return currentSearch;
        }

        function fieldErrorValidation(inputFieldArray) {
            let emptyFields = false;
            for (let i = 0; inputFieldArray.length > i; i++) {
                if (inputFieldArray[i].inputField.val() === '') {
                    inputFieldArray[i].inputField.parent().addClass('is-error');
                    inputFieldArray[i].errorField.removeClass('hidden');
                    emptyFields = true;
                } else {
                    inputFieldArray[i].inputField.parent().removeClass('is-error');
                    inputFieldArray[i].errorField.addClass('hidden');
                }
            }

            return emptyFields;
        }

        $j("#btnFlightSearchFormSubmitMobile").on("click", function(e) {
            e.preventDefault();

            let emptyFormFields = false;
            let currentSearch = getCurrentSearchFields();
            let errorValidationFields = [];

            if (currentSearch.tripType === 'oneWay') {
                errorValidationFields = [currentSearch.originAirport,
                        currentSearch.destinationAirport,
                        currentSearch.originTravelDate,
                        currentSearch.travelType];
            } else if (currentSearch.tripType === 'roundTrip') {
                errorValidationFields = [currentSearch.originAirport,
                        currentSearch.destinationAirport,
                        currentSearch.originTravelDate,
                        currentSearch.destinationTravelDate,
                        currentSearch.travelType]
            }

            emptyFormFields = fieldErrorValidation(errorValidationFields);

            if (document.getElementById("awardBooking2").checked) {
                $j(this)
                    .parents("form:first")
                    .submit();
            } else if (!emptyFormFields) {
                $j("body")
                    .aaBusy({
                        message: AAUI.getProperty("loadingTxt"),
                        form: $j(this).parents("form:first")
                    })
                    .start();
            }
        });

        var _initDatePicker = function() {
            AAUI.initDatePicker(".aaDatePicker", {
                beforeShowDay: _highlightSelectDates,
                onSelect: _handleDateSelect,
                showOn: 'button'
            });
        };

        var _initMobileDatePicker = function(options) {
            AAUI.initMobileDatePicker(options);
        };

        var _handleDateSelect = function(selectedDate, event) {
            var instance = $j(this).data("datepicker"),
                date = $j.datepicker.parseDate(
                    instance.settings.dateFormat || $j.datepicker._defaults.dateFormat,
                    selectedDate,
                    instance.settings
                );
            userSelectedDate = true;
            switch (event.id) {
                case "aa-leavingOn":
                    if ($returningDateField.datepicker("getDate") < $departingDateField.datepicker("getDate")) {
                        $returningDateField.datepicker("setDate", "");
                    }
                    $returningDateField.datepicker("option", "minDate", date);
                    AAUI.initDatepickerA11Y();
                    $j(".aaDatePicker").datepicker("refresh");
                    departingDateFieldIsDirty = true;
                    break;
                case "aa-returningFrom":
                    returningDateFieldIsDirty = true;
                    $j(".aaDatePicker").datepicker("refresh");
                    break;
            }
            if (_getSelectedFindFlightType() === "roundTripHotel") {
                defaultWasSetOnRoundTripHotel = false;
            }
            AAUI.datePickerA11Y();
        };

        var _highlightSelectDates = function(date) {
            try {
                var date1 = $j.datepicker.parseDate($j.datepicker._defaults.dateFormat, $departingDateField.val());
                var date2 = $j.datepicker.parseDate($j.datepicker._defaults.dateFormat, $returningDateField.val());
                return [
                    true,
                    date1 && (date.getTime() == date1.getTime() || (date2 && date >= date1 && date <= date2)) ?
                    "aa-highlight" :
                    ""
                ];
            } catch (error) {
                return [true, ""];
            }
        };

        var _escapeHtml = function(text) {
            return String(text)
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#39;");
        }

        var _viewReservationList = function() {
            var isMobileView = $j(".mobile-tab-container").length > 0;
            if (AAUI.getProperty("account.isSecure") === "true") {
                AAUI.ajaxRequest({
                    url: "/home/ajax/mytrips",
                    type: "GET",
                    dataType: "json",
                    busyContainer: $j("#aa-viewReservations").parent(),
                    busyMessage: AAUI.getProperty("loadingTxt"),
                    timeout: 50000,
                    onSuccess: function(jsonResponse, textStatus) {
                        if (jsonResponse && textStatus == "success") {
                            if (jsonResponse.errorCode) {
                                $j("#aa-viewReservationsSecure")
                                    .empty()
                                    .html(
                                        '<p><span class="message-error" aria-hidden="true"></span><span>' +
                                        jsonResponse.errorMessage +
                                        "</span></p>"
                                    );
                            } else {
                                jsonResponse.visibleReservations = jsonResponse.reservations.slice(0, 5);         
                                if(jsonResponse.reservations.length > 0){
                                    $j("#aa-withReservationsTemplate").show();
                                    $j("#aa-reservationsBody").empty();
                                    jsonResponse.visibleReservations.forEach(function(reservation, index) {
                                        const recordLocator = _escapeHtml(reservation.recordLocator);
                                        const departureDate = _escapeHtml(reservation.departureDate);
                                        const reservationName = _escapeHtml(reservation.reservationName);
                                        const originAirportCode = _escapeHtml(reservation.originAirportCode || "");
                                        const accessibleText = `${reservationName},${departureDate}`;

                                        let rowHtml = '';
                                        if (isMobileView) {
                                            rowHtml = `<tr>
                                                <td>${departureDate}</td>
                                                <td>${reservationName}</td>
                                                <td class="text-center" scope="row">
                                                    <a class="call-to-action no-wrap-important" href="/reservation/selectReservationSubmit.do?fromHomePage=true&amp;recordLocator=${recordLocator}">
                                                        ${viewChangeText}<span class="hidden-accessible">${accessibleText}</span>
                                                    </a>
                                                </td>
                                            </tr>`;
                                        } else {
                                            rowHtml = `<tr>
                                                <td>${departureDate}</td>
                                                <td>${originAirportCode}</td>
                                                <td>${reservationName}</td>
                                                <td class="text-center" scope="row">
                                                    <a class="call-to-action" href="/reservation/selectReservationSubmit.do?fromHomePage=true&amp;recordLocator=${recordLocator}">
                                                        ${viewChangeText}<span class="hidden-accessible">${accessibleText}</span>
                                                    </a>
                                                </td>
                                            </tr>`;
                                        }
                                        $j("#aa-reservationsBody").append(rowHtml);
                                    });
                                    if(jsonResponse.reservations.length > 5){
                                        $j("#viewall-flights").show();
                                    }
                                } else {
                                    $j("#aa-noReservationsTemplate").show();
                                }
                            }
                        } else {
                            $j("#aa-viewReservationsSecure")
                                .empty()
                                .html(
                                    '<p><span class="message-error" aria-hidden="true"></span><span>' +
                                    AAUI.getProperty("global.error") +
                                    "</span></p>"
                                );
                        }
                    },
                    onError: function() {
                        $j("#aa-viewReservationsSecure")
                            .empty()
                            .html(
                                '<p><span class="message-error" aria-hidden="true"></span><span>' +
                                AAUI.getProperty("global.error") +
                                "</span></p>"
                            );
                    },
                    onComplete: function() {
                        $j("#aa-viewReservationsSecure >> *:first-child:visible")
                            .attr("tabindex", "-1")
                            .attr("aria-live", "polite")
                            .focus();
                        if(isMobileView) {
                            $j("html, body").animate({
                                    scrollTop: $j("#jq-myTripsCheckIn").height() + $j(".mobile-tab-container").offset().top + 1
                                },
                                500
                            );
                        }
                    }
                });
            }
        };

        var _initAccordion = function() {
            var accordion = $j(".mobile-tab-container").accordion({
                active: false,
                collapsible: true,
                header: "h2",
                icons: false,
                heightStyle: "content",
                beforeActivate: function(event, ui) {
                    if (ui.newHeader.length > 0) {
                        if (ui.newHeader[0].id === "jq-myTripsCheckIn") {
                            _viewReservationList();
                        }
                        ui.newHeader
                            .find('[class*="icon-"]')
                            .removeClass("icon-expand")
                            .addClass("icon-collapse");
                        $j(".mobile-tab-container").addClass("expanded");

                        var topOfContainer = $j(".mobile-tab-container").offset().top + 1;
                        var index = $j(".acc-tab").index(ui.newHeader);
                        $j("html, body").animate({
                                scrollTop: index *
                                    $j(".acc-tab")
                                    .first()
                                    .height() +
                                    topOfContainer
                            },
                            500
                        );
                    }
                    if (ui.oldHeader.length > 0) {
                        ui.oldHeader
                            .find('[class*="icon-"]')
                            .removeClass("icon-collapse")
                            .addClass("icon-expand");
                        //to handle accessibility bug in jQueryUI 1.10.4
                        ui.oldHeader.attr("aria-expanded", false);
                        if (ui.newHeader.length === 0) {
                            $j(".mobile-tab-container").removeClass("expanded");
                        }
                    }
                }
            });
        };

        function setActiveTab() {
            var activeTab = AAUI.getQueryStringParameterByName("activeTab");
            if (activeTab && activeTab > 0 && activeTab < 3) {
                $j("#booking-module-tabs").tabs("option", "active", activeTab);
            }
        }

        function captureActiveTab(ui) {
            var $moduleTabs = $j("#booking-module-tabs"),
                loginFormActiveTab = $j("#loginForm\\.activeTab")[0];

            // Save the tab the user is currently viewing (find flights/checkin/flight status)
            // and switch to correct view after login
            if (loginFormActiveTab && $moduleTabs.length) {
                loginFormActiveTab.value = $moduleTabs.tabs("option", "active");
            }
        }

        function intOnly(value) {
            return /^-?\d*$/.test(value);
        }

        function scrubUrl(uri, key, value) {
            var re = new RegExp("([?&])("+ key + "=)[^&#]*", "g");
            if (uri.match(re)) {
                return uri.replace(re, '$1$2' + value);
            }

            var paramString = (uri.indexOf('?') < 0 ? "?" : "&") + key + "=" + value;
            var hashIndex = uri.indexOf('#');
            if (hashIndex < 0) {
                return uri + paramString;
            } else {
                return uri.substring(0, hashIndex) + paramString + uri.substring(hashIndex);
            }
        }

        function initFindReservationForm() {
            let findReservationForm = $j("#findReservationForm"),
                manageTripsHomeWidget = findReservationForm.find("#manageTripsHomeWidget"),
                canceledTripsHomeWidget = findReservationForm.find("#canceledTripsHomeWidget"),
                cancelTripLearnMoreMessage = findReservationForm.find("#cancelTripLearnMore"),
                canceledTripsSelection = findReservationForm.find("#canceledTripsSelection"),
                checkInTopMessage = findReservationForm.find("#checkInTopMessage"),
                recordLocatorRequiredIcon = findReservationForm.find("#recordLocatorRequiredIcon"),
                ticketNumber = findReservationForm.find("input[name=ticketNumber]"),
                recordLocator = findReservationForm.find("input[name=recordLocator]"),
                lastName = findReservationForm.find("input[name=lastName]");

            cancelTripLearnMoreMessage.hide();
            canceledTripsSelection.hide();

            setTimeout(function() {
                $j("#findYourTripsCreditChecks").click(function() {
                    $j("#jq-myTripsCheckIn").trigger("click");
                    $j("#canceledTripsHomeWidget").trigger("click").focus();

                    let reservationTab = $j("#aa-tab-viewReservations");
                    if (reservationTab && !$device.mobile) {
                        let top = reservationTab.offset().top;
                        window.scrollTo(0, top);
                    }

                    findYourTripsCreditChecksClicked = true;

                    return false;
                });

                $j("#globalMessageClose").click(function() {
                    $j("#globalMessageContainer").hide();

                    return false;
                });
            }, 500);


            manageTripsHomeWidget.on("change", function() {
                checkInTopMessage.show();
                recordLocatorRequiredIcon.show();
                cancelTripLearnMoreMessage.hide();
                canceledTripsSelection.hide();
            });

            canceledTripsHomeWidget.change(function() {
                cancelTripLearnMoreMessage.show();
                canceledTripsSelection.show();
                checkInTopMessage.removeAttr("style").hide();
                recordLocatorRequiredIcon.hide();
            });

            ticketNumber.on("input keydown keyup", function(evt) {
                if (intOnly(this.value)) {
                    this.oldValue = this.value;
                    this.oldSelectionStart = this.selectionStart;
                    this.oldSelectionEnd = this.selectionEnd;
                } else if (this.hasOwnProperty("oldValue")) {
                    this.value = this.oldValue;
                    this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
                } else {
                    this.value = "";
                }
            });

            findReservationForm.on("submit", function(evt) {
                let findReservationFormAction = findReservationForm.attr("action"),
                    findReservationFormRadioInput = $j("#findYourTripFor input[type=radio][name=findYourTripFor]:checked");

                let cleanUrl;

                if (findYourTripsCreditChecksClicked) {
                    cleanUrl = scrubUrl(findReservationFormAction, "from", "canceledTripsAlert");
                } else {
                    sessionStorage.setItem('inputEmdLastName', lastName.val());
                    sessionStorage.setItem('inputTicketNumber', ticketNumber.val());
                    sessionStorage.setItem('recordLocator', recordLocator.val());
                    sessionStorage.setItem('lastName', lastName.val());
                    sessionStorage.setItem('locale',AAUI.getProperty("user.locale"));

                    cleanUrl = scrubUrl(findReservationFormAction, "from", findReservationFormRadioInput.val());
                }

                $j("body")
                    .aaBusy({
                            message: AAUI.getProperty("loadingTxt"),
                        }
                    )
                    .start();

                findReservationForm.attr("action", cleanUrl);

                return true;
            });
        }

        var _initCoachMarkTrigger = function() {
            AAUI.onClick('[data-behavior="coachMark"] .coachmark-close', function (e) {
                $j(this).parent().hide();
            });
        };

        var _initPage = function(pageLoad) {
            pageLoad = pageLoad || false;

            if (pageLoad) {
                initializePassengersDropdown();
                _initializeAirportInput();
                _updateFindFlightsView(_getSelectedFindFlightType());
                initTripLink();

                if (typeof $device !== "undefined" && $device.mobile && $device.viewport() !== "desktop") {
                    initTripLinkMobile();
                    bookingForm({
                            tripType: AAcom.prototype.getProperty("tripType"),
                            dateFormat: AAcom.prototype
                                .getProperty("dateFormat")
                                .replace(/MM/g, "mm")
                                .replace(/yy/g, "y"),
                            bookingType: AAcom.prototype.getProperty("awardBooking") ?
                                "awardBooking" : "revenueBooking",
                            refundable: AAcom.prototype.getProperty("refundable"),
                            cabinType: AAcom.prototype.getProperty("cabinType")
                        },
                        $j.fn.aaRecentSearch({
                            originAirportInputId: "#segments0.origin",
                            destinationAirportInputId: "#segments0.destination",
                            departDateInputId: "#departDate",
                            returnDateInputId: "#returnDate"
                        }),
                        _initMobileDatePicker
                    );
                } else {
                    _initBookingForm();
                }
                initReactivateDialog();
                _initCoachMarkTrigger();

                AAUI.initAutoComplete(".aaAutoComplete", false, {
                    position: {
                        collision: "flip"
                    }
                });
                AAUI.initNearestAirportLookup(".current-location-btn");
                _initDatePicker();
                if (!$device.mobile && typeof aaHeroSlides !== typeof undefined && aaHeroSlides.length > 0) {
                    $j("#aa-hp-ad-hero").aaHeroAds(aaHeroSlides);
                } else {
                    _initAccordion();
                }

                AAUI.populateSpecificFlightSearchDateDropdown($j("#travelDate"), true, $j("#clientLocalTime"));

                setActiveTab();

                if ("serviceWorker" in navigator) {
                    navigator.serviceWorker.register("service-worker.js");
                }
            }

            initFindReservationForm();
        };

        /* Moving from document ready because tabs need to be initialized at the earliest to allow user interaction */
        $j("#booking-module-tabs").tabs({
            activate: function(event, ui) {
                captureActiveTab();

                if (ui.newTab.attr("id") == "aa-tab-viewReservations") {
                    _viewReservationList();
                }
            }
        });

        // if (window.Worker) {
        //     handlebarWorker = new Worker("assets/js/webworker/handlebar-worker.min.js");
        //     handlebarWorker.onmessage = function(e) {
        //         switch (e.data.key) {
        //             case "viewReservations":
        //                 $j("#" + e.data.templateContainer)
        //                     .empty()
        //                     .html(e.data.html);
        //                 $j("#aa-viewReservationsSecure *:first")
        //                     .attr("tabindex", "-1")
        //                     .focus();
        //                 break;
        //             default:
        //                 $j("#" + e.data.templateContainer)
        //                     .empty()
        //                     .html(e.data.html);
        //                 break;
        //         }
        //     };
        //     handlebarWorker.postMessage({
        //         action: "addTemplate",
        //         key: "viewReservations",
        //         data: $j("#viewReservations-template").html()
        //     });
        // } else {
        //     $j.getScript("assets/js/webworker/handlebar-no-worker.min.js", function(data, textStatus, jqxhr) {
        //         handlebarWorker = { postMessage: onMessage };
        //         handlebarWorker.postMessage({
        //             action: "addTemplate",
        //             key: "viewReservations",
        //             data: $j("#viewReservations-template").html()
        //         });
        //     });
        // }

        AAUI.populateBagInputs = function() {
            var searchBy = $j("#searchBy")
                .find("option:selected")
                .val();
            var recordLocInput = $j("#recordLocNum");

            if (searchBy == "bagTagNumber") {
                recordLocInput.hide();
                AAUI.initClearInput("#recordLoc");
                $j("#bagTagNum").show();
            } else {
                recordLocInput.show();
                AAUI.initClearInput("#bagTagNum");
                $j("#bagTagNum").hide();
            }
        };

        AAUI.initBagTrackerSearchBy = function() {
            AAUI.populateBagInputs();
            AAUI.onChange('select[name="searchBy"]', function() {
                AAUI.populateBagInputs();
            });
        };

        AAUI.initCollapse = function() {
            var bags = $j(".historyTableLink");
            if (bags.length) {
                bags.each(function(index, bag) {
                    AAUI.collapse({
                        selector: "#" + bag.id,
                        target: $j(bag).data("href"),
                        collapsed: true,
                        accessibleText: {
                            hide: AAUI.getProperty("bagTrackerHide"),
                            show: AAUI.getProperty("bagTrackerShow")
                        }
                    }).init();
                });
            }
        };

        AAUI.initClearInput = function(input) {
            AAUI.resetFormFields(input);
            AAUI.clearFormErrors(input);
        };

        $j(document).ready(function() {
            AAUI.initBagTrackerSearchBy();
            AAUI.initCollapse();
        });

        $j(document).ready(function() {
            _initPage(true);
            if (AAUI.getProperty("account.isSecure") == "false") {
                AAUI.sessionTimeOutDialog.stopTimers();
            }
        });

        AAUI.onChange("#travelType", function() {
            var selectedValue = $j(this).val();
            if (selectedValue === 'business') {
                $j('.dynamicTravelTypeLayout').removeClass('span4').addClass('span3');
                $j('.corporateNameDiv').show();
                _toggleTripLink(true);
                _setTripLinkToSession(true); // smb later? corporate? do both do same search?
            } else if (selectedValue === 'airpass') {
                $j('.dynamicTravelTypeLayout').removeClass('span3').addClass('span4');
                $j('.corporateNameDiv').hide();
                _toggleAirpass(true);
                _setAirPassToSession(true);
            } else {
                $j('.dynamicTravelTypeLayout').removeClass('span3').addClass('span4');
                $j('.corporateNameDiv').hide();
                _toggleTripLink(false);
                _toggleAirpass(false);
                _setTripLinkToSession(false);
                _setAirPassToSession(false);
            }
        });
    }
);
